<!-- 监测数据 -->
<template>
    <div v-if="componentsData.type == 24">
        <div class="overflow-hidden bg-div"
            :style="{
                ...(componentsData.content.bg_color && { backgroundColor: componentsData.content.bg_color }),
                ...(componentsData.content.bg_img.picview && componentsData.content.bg_value && { backgroundImage: `url(${componentsData.content.bg_img.picview})` }),
                padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`
            }"
        >
            <template v-if="componentsData.content.style_value == 1">
                <div class="box-div">
                    <div v-for="(item, index) of componentsData.content.menuList" :key="index" class="box" :style="`border-bottom: 1px solid ${componentsData.content.border_color}`">
                        <div :style="`font-size: ${componentsData.content.name_size}px;color: ${componentsData.content.name_color};`">{{item.text.name}}</div>
                        <div :style="`font-size: ${componentsData.content.txt_size}px;color: ${componentsData.content.txt_color};`" class="fw-b mtb-6">{{item.text.txt}}</div>
                        <div :style="`font-size: ${componentsData.content.norm_size}px;color: ${componentsData.content.norm_color};`">{{item.text.norm}}</div>
                    </div>
                </div>
            </template>
            <template v-if="componentsData.content.style_value == 2">
                <div class="card-header" :class="{ 'center-layout': componentsData.content.menuList.length <= 3 }" :style="`background:${componentsData.content.title_bg_color};`">
                    <div v-for="(item, index) of componentsData.content.menuList" :key="index" class="card-content"
                        :style="index == 0 ? firstItemStyle : otherItemsStyle"
                    >
                        {{item.title}}
                    </div>
                </div>
                <div class="img-div">
                    <img src="@/assets/monitor/number.png" alt="" class="image">
                    <div class="img-position">
                        <div class="fw-b"
                            :style="`font-size: ${componentsData.content.txt_size}px;color: ${componentsData.content.txt_color};`"
                        >
                            {{componentsData.content.menuList[0].text.txt}}
                        </div>
                        <div 
                            :style="`font-size: ${componentsData.content.name_size}px;color: ${componentsData.content.name_color};`"
                        >
                            {{componentsData.content.menuList[0].text.name}}
                        </div>
                    </div>
                </div>
                <div v-if="componentsData.content.menuList[0].remark" class="flex-c mb-24">
                    <div class="remark-div" :style="`color: ${componentsData.content.remark_color};`">{{componentsData.content.menuList[0].remark}}</div>
                </div>
                <div class="flex-c fs-14" :style="`color: ${componentsData.content.other_color};`">
                    <div class="flex-c mr-24">
                        <img src="@/assets/monitor/circle-active.png" alt="" class="img-icon">
                        实测值
                    </div>
                    <div class="flex-c">
                        <img src="@/assets/monitor/circle.png" alt="" class="img-icon">
                        标准值
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        firstItemStyle() {
            return {
                fontSize: this.componentsData.content.title_size + 'px',
                color: this.componentsData.content.title_color_active,
                background: this.componentsData.content.title_bg_color_active,
            };
        },
        otherItemsStyle() {
            return {
                fontSize: this.componentsData.content.title_size + 'px',
                color: this.componentsData.content.title_color,
                background: this.componentsData.content.title_bg_color,
            };
        }
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.box-div {
    display: flex;
    flex-wrap: wrap;
}
.box {
    width: 50%;
    padding-bottom: 36px;
    margin-bottom: 36px;
}
.box:nth-last-child(-n+2) {
    width: 50%;
    padding-bottom: 0;
    margin-bottom: 0;
    border: none !important;
}
.fw-b {
    font-weight: bold;
}
.card-header {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 4px;
    overflow: hidden;
}
.center-layout {
    justify-content: center;
}
.card-content {
    padding: 12px 0;
    text-align: center;
    min-width: 33.333%;
    width: 33.333%;
    max-width: 33.333%;
    border-radius: 4px;
    white-space: nowrap;
}
.img-div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 12px;
    position: relative;
}
.image {
    width: 100%;
    height: 100%;
}
.flex-c {
    display: flex;
    align-items: center;
    justify-content: center;
}
.remark-div {
    background-color: #eee;
    border-radius: 20px;
    padding: 6px 22px;
    border: 2px solid #fff;
}
.fs-14 {
    font-size: 14px;
}
.img-icon {
    margin-right: 12px;
    width: 13px;
    height: 13px;
}
.img-position {
    position: absolute;
    left: auto;
    right: auto;
    bottom: 55px;
    text-align: center;
}
.mtb-6 {
    margin: 6px 0;
}
</style>